import React, { Component } from 'react';
import '../../../styles/scss/style.css';

//Components
import TextParagraph from '../atoms/TextParagraph';
import FormMinimalTextarea from '../atoms/FormMinimalTextarea';
import Icon from '../atoms/Icon';

//Returning the component
class BotAnswer extends Component {
	render() {
		return (
					<div className={`botAnswer ${this.props.classType}`}>
						<TextParagraph classType="botAnswer__number"text={this.props.answerNumber} href={this.props.href} />
						<FormMinimalTextarea 
							placeholder={this.props.placeholder} 
							onChange={this.props.onChange}
							handleBlur={this.props.handleBlur}
							value={this.props.value}
							name={this.props.name}
							id={this.props.id}
						/>
						{this.props.showDelete &&
						<Icon classType="fa-trash answerBuilder__delete" role="button" onClick={this.props.onClick} />
						}
					</div>
		)
	}
}

//Making sure that it has a text property when it's declared
// BotAnswer.propTypes = {
// 	answerNumber: PropTypes.string.isRequired,
// 	placeholder: PropTypes.string.isRequired
// }

export default BotAnswer;


// WEBPACK FOOTER //
// ./src/redux/components/molecules/BotAnswer.jsx